import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { useCallback } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useTryToRequestFunnelsPages } from '../hooks/useTryToRequestFunnelsPages';
import { useTryToRequestRemoveFunnelPage } from '../hooks/useTryToRequestRemoveFunnelPage';

type PageType =
  | 'Pergunta'
  | 'Mídia'
  | 'Oferta'
  | 'Funcionalidade'
  | 'Vídeo'
  | 'Atendimento especialista'
  | 'Lançamento';

interface TableDropdownProps {
  item: {
    key: string;
    name: string;
    pageType: PageType;
    status: string;
  };
}

interface RedirectionToEditFunnelPageProps {
  pageType: PageType;
  pageId: string;
  funnelTypeId: string;
}

export const TableDropdown = ({ item }: TableDropdownProps) => {
  const { id: funnelTypeId } = useParams<{ id?: string }>();
  const { funnelsPageRefetch } = useTryToRequestFunnelsPages(funnelTypeId);
  const { tryToRequestRemoveFunnelPage } = useTryToRequestRemoveFunnelPage();
  const navigate = useNavigate();

  const handleRedirectionToEditFunnelPage = useCallback(
    ({ pageType, pageId, funnelTypeId }: RedirectionToEditFunnelPageProps) => {
      switch (pageType) {
        case 'Pergunta':
          return `/unsubscribe/funnel/question/${funnelTypeId}?pageId=${pageId}`;
        case 'Mídia':
          return `/unsubscribe/funnel/media/${funnelTypeId}?pageId=${pageId}`;
        case 'Oferta':
          return `/unsubscribe/funnel/offer/${funnelTypeId}?pageId=${pageId}`;
        case 'Funcionalidade':
          return `/unsubscribe/funnel/functionality/${funnelTypeId}?pageId=${pageId}`;
        case 'Atendimento especialista':
          return `/unsubscribe/funnel/specialist-care/${funnelTypeId}?pageId=${pageId}`;
        case 'Vídeo':
          return `/unsubscribe/funnel/video/${funnelTypeId}?pageId=${pageId}`;
        case 'Lançamento':
          return `/unsubscribe/funnel/release/${funnelTypeId}?pageId=${pageId}`;
        default:
          return '';
      }
    },
    []
  );

  const handleRemoveFunnelPage = useCallback(async () => {
    await tryToRequestRemoveFunnelPage(item.key).then(() => {
      funnelsPageRefetch?.();
    });
  }, [item, funnelsPageRefetch]);

  const menuItems = [
    {
      key: 'edit',
      label: (
        <div
          onClick={(e: any) => {
            e.stopPropagation();
            const redirect = handleRedirectionToEditFunnelPage({
              pageType: item.pageType,
              pageId: item.key,
              funnelTypeId: funnelTypeId || '',
            });
            navigate(redirect);
          }}
        >
          <EditOutlined style={{ marginRight: '12px' }} />
          Editar
        </div>
      ),
    },
    {
      key: 'delete',
      label: (
        <div
          onClick={(e: any) => {
            e.stopPropagation();
            handleRemoveFunnelPage();
          }}
          style={{ color: '#E84749' }}
        >
          <DeleteOutlined style={{ marginRight: '12px', color: '#E84749' }} />
          Deletar
        </div>
      ),
    },
  ];

  return (
    <Dropdown trigger={['click']} arrow={false} menu={{ items: menuItems }}>
      <ButtonMenu type='text'>
        <MoreOutlined />
      </ButtonMenu>
    </Dropdown>
  );
};

const ButtonMenu = styled(Button)`
  &:focus {
    color: #3c89e8 !important;
  }
`;
